import script from "./TextEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextEditor.vue?vue&type=script&setup=true&lang=ts"

import "./TextEditor.vue?vue&type=style&index=0&id=4390f456&lang=scss"

const __exports__ = script;

export default __exports__